import type {ApiWorkforceProfileRecord} from '../WorkforceProfiles/workforceProfileApiTypes';

import type {
  SeniorityLevelDelta,
  WorkforceProfileSeniorityLevelAssessment,
} from '../../types/workforceProfilesSharedTypes';

const LEVEL_DELTAS: SeniorityLevelDelta[] = ['at', 'above', 'below', 'uncertain'];

const isLevelDelta = (value: unknown): value is SeniorityLevelDelta =>
  typeof value === 'string' && LEVEL_DELTAS.includes(value as SeniorityLevelDelta);

export const mapSeniorityLevelAssessment = (
  raw: ApiWorkforceProfileRecord | undefined
): WorkforceProfileSeniorityLevelAssessment | null => {
  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const levelDelta = raw.levelDelta;
  const explanation = typeof raw.explanation === 'string' ? raw.explanation.trim() : '';

  if (!isLevelDelta(levelDelta) || !explanation) {
    return null;
  }

  return {
    assignedSeniority: typeof raw.assignedSeniority === 'string' ? raw.assignedSeniority : null,
    evidencedLevel: typeof raw.evidencedLevel === 'string' ? raw.evidencedLevel : null,
    levelDelta,
    explanation,
  };
};
